<dx-popup [width]="300"
          [height]="200"
          [showTitle]="true"
          [title]="this.title"
          [dragEnabled]="false"
          [closeOnOutsideClick]="true"
          [(visible)]="this.popupVisible">
  <div [innerHTML]="this.message"></div>
</dx-popup>
